// src/views/menage/CarteControleAgent.jsx — LA CARTE D'UN CONTRÔLE dans la
// journée de l'agent contrôleur, d'après la maquette NEST v677 (`carteCtl`) :
// « avant 16h », « Contrôle · <logement> », « ménage de Karim terminé à 12h55 ·
// à contrôler avant 16h, la prochaine arrivée possible », l'adresse, le code,
// « Contrôler ce ménage ». Pas d'heure fixée : l'échéance suffit.
// « Signaler un incident » (maquette, 28/10 : partout où l'agent est sur place) :
// le ménage est celui d'un autre, l'incident porte le logement seul (`run_id` nul).

import { nomProduit } from '../../lib/consommables-helpers'
import { heureFinParis } from '../../lib/agent-journee-regles'
import { CartePlanning, LigneAcces, BoutonCarte, BoutonIncident } from './CartePlanning'
import { NEST } from './palette-nest'

function heureFR(hhmm) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ''))
  if (!m) return null
  return m[2] === '00' ? `${Number(m[1])}h` : `${Number(m[1])}h${m[2]}`
}

// L'ÉCHÉANCE — l'arrivée d'abord (elle presse), le contrat en repli, et
// l'absence SE DIT (jamais un « 16h » inventé).
// ⚠️ MAQUETTE NEST v677 (lot G2, 30/10) — un contrôle confié ne montre QUE
// l'heure limite (« à contrôler avant 16h ») : jamais le voyageur. Le serveur
// ne l'envoie plus au rôle ménage.
export function heureLimiteControle(menage) {
  return heureFR(menage?.prochaine_arrivee?.heure) || heureFR(menage?.heure_contrat)
}

export function libelleEcheanceControle(menage) {
  const arr = menage?.prochaine_arrivee
  const hArr = heureFR(arr?.heure)
  if (hArr) return `À contrôler avant ${hArr}`
  const hContrat = heureFR(menage?.heure_contrat)
  if (hContrat) return `À contrôler avant ${hContrat}`
  return "À contrôler aujourd'hui — heure d'arrivée non configurée"
}

export default function CarteControleAgent({ menage, cfg, info, habit = 'grand', onControler, onIncident, ancre }) {
  const manques = Array.isArray(menage?.manques_aujourdhui) ? menage.manques_aujourdhui : []
  const nomP = (m) => (m.cs_id ? nomProduit(cfg, m.cs_id) : m.texte)
  const code = (info?.codes_acces?.boite_cles && String(info.codes_acces.boite_cles).trim()) || null
  const nom = info?.nom || menage?.logement_nom || 'un logement'
  const limite = heureLimiteControle(menage)
  const agent = menage?.agent_prenom || null
  const fini = heureFinParis(menage?.completed_at)
  const sousTitre = [
    agent ? `ménage de ${agent}${fini ? ` terminé à ${fini}` : ''}` : null,
    limite ? `à contrôler avant ${limite}, la prochaine arrivée possible` : "à contrôler aujourd'hui",
  ].filter(Boolean).join(' · ')

  return (
    <div ref={ancre}>
      <CartePlanning testId={`carte-controle-jour-${menage.run_id}`} habit={habit} teinte="aub"
        heure={limite ? `avant ${limite}` : null} titre={`Contrôle · ${nom}`} sousTitre={sousTitre}>
        {manques.length > 0 && (
          <div data-testid={`controle-manques-${menage.run_id}`} style={{ background: NEST.aubPale, borderLeft: `3px solid ${NEST.aub}`,
            borderRadius: '0 10px 10px 0', padding: '8px 11px', fontSize: 13, color: NEST.aubTexte }}>
            <b>Il manque :</b> {manques.map(nomP).filter(Boolean).join(', ')}
          </div>
        )}
        <LigneAcces adresse={info?.adresse_complete || menage?.adresse} cp={info?.code_postal} ville={info?.ville} code={code}
          testIdGps={`controle-gps-${menage.run_id}`} testIdCode={`controle-code-${menage.run_id}`} />
        <BoutonCarte testId={`controle-ouvrir-${menage.run_id}`} onClick={() => onControler(menage)}>
          Contrôler ce ménage
        </BoutonCarte>
        {onIncident && <BoutonIncident testId={`controle-incident-${menage.run_id}`} onClick={() => onIncident(menage)} />}
      </CartePlanning>
    </div>
  )
}
